import React, { useState, useEffect } from "react";
import { FaPlus, FaTimes } from "react-icons/fa";

const CryptoAccountForm = ({ 
  initialData = {}, 
  onSubmit, 
  isLoading = false, 
  isEdit = false 
}) => {
  const [formData, setFormData] = useState({
    exchange_name: "",
    token_name: "",
    no_of_tokens: "0.00000000",
    ...initialData
  });
  const [contacts, setContacts] = useState([{ name: "", contact: "" }]);

  useEffect(() => {
    if (initialData.contacts && initialData.contacts.length > 0) {
      setContacts(initialData.contacts);
    }
  }, [initialData]);

  const handleContactChange = (index, field, value) => {
    const updatedContacts = [...contacts];
    updatedContacts[index][field] = value;
    setContacts(updatedContacts);
  };

  const addContact = () => {
    setContacts([...contacts, { name: "", contact: "" }]);
  };

  const removeContact = (index) => {
    if (contacts.length > 1) {
      setContacts(contacts.filter((_, i) => i !== index));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submitData = {
      ...formData,
      contacts: contacts.filter((c) => c.name.trim() && c.contact.trim()),
    };
    onSubmit(submitData);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <label className="block text-sm font-semibold text-slate-700">
            Exchange Name *
          </label>
          <input
            type="text"
            value={formData.exchange_name}
            onChange={(e) => handleInputChange("exchange_name", e.target.value)}
            placeholder="e.g., Binance, Coinbase"
            required
            className="w-full px-4 py-3 border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white font-medium"
          />
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-semibold text-slate-700">
            Token Name *
          </label>
          <input
            type="text"
            value={formData.token_name}
            onChange={(e) => handleInputChange("token_name", e.target.value)}
            placeholder="e.g., BTC, ETH"
            required
            className="w-full px-4 py-3 border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white font-medium"
          />
        </div>
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-semibold text-slate-700">
          Number of Tokens
        </label>
        <input
          type="number"
          step="0.00000001"
          value={formData.no_of_tokens}
          onChange={(e) => handleInputChange("no_of_tokens", e.target.value)}
          placeholder="0.00000000"
          className="w-full px-4 py-3 border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white font-medium"
        />
      </div>

      {/* Contact Persons Section */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h4 className="text-lg font-semibold text-slate-800">
            Contact Persons
          </h4>
          <button
            type="button"
            onClick={addContact}
            className="flex items-center space-x-2 px-3 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            <FaPlus className="w-4 h-4" />
            <span>Add Contact</span>
          </button>
        </div>

        {contacts.map((contact, index) => (
          <div key={index} className="flex space-x-4 items-end">
            <div className="flex-1 space-y-2">
              <label className="block text-sm font-semibold text-slate-700">
                Contact Name
              </label>
              <input
                type="text"
                value={contact.name}
                onChange={(e) => handleContactChange(index, "name", e.target.value)}
                placeholder="Enter contact name"
                className="w-full px-4 py-3 border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white font-medium"
              />
            </div>

            <div className="flex-1 space-y-2">
              <label className="block text-sm font-semibold text-slate-700">
                Contact Info
              </label>
              <input
                type="text"
                value={contact.contact}
                onChange={(e) => handleContactChange(index, "contact", e.target.value)}
                placeholder="Phone or email"
                className="w-full px-4 py-3 border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white font-medium"
              />
            </div>

            {contacts.length > 1 && (
              <button
                type="button"
                onClick={() => removeContact(index)}
                className="px-3 py-3 bg-red-500 text-white rounded-xl hover:bg-red-600 transition-colors"
              >
                <FaTimes className="w-4 h-4" />
              </button>
            )}
          </div>
        ))}
      </div>

      <div className="flex space-x-4 pt-4">
        <button
          type="submit"
          disabled={isLoading}
          className="flex-1 flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 font-semibold shadow-lg shadow-blue-500/25 transition-all duration-200 disabled:opacity-50"
        >
          <span>{isLoading ? "Saving..." : isEdit ? "Update Asset" : "Register Asset"}</span>
        </button>
      </div>
    </form>
  );
};

export default CryptoAccountForm;









